import React, { Component } from 'react';
import { Switch, withRouter } from 'react-router-dom';
import './MainContent.scss';
import JurisdictionSelectContainer from '../../jurisdiction/jurisdiction-select-container/JurisdictionSelectContainer';
import MaterialIcon from 'material-icons-react';
import { hidesJurisdictionSelect, routes } from '../routes';
import { connect } from 'react-redux';
import { SandboxBanner } from '../../shared/sandbox/SandboxBanner';

const EmptyComponent = () => null;
const connectTitleComponent = (titleComponent = EmptyComponent) =>
    connect(state => ({
        state
    }))(titleComponent);

class MainContent extends Component {
    render() {
        return (
            <div className="main-content">
                <div className={'header'}>
                    <div className={'title-wrapper'}>
                        <MaterialIcon
                            icon="menu"
                            onClick={() => this.props.toggleCollapse()}
                        />
                        <span className={'title page-header'}>
                            <Switch
                                children={routes.map(route => ({
                                    ...route,
                                    props: {
                                        ...route.props,
                                        component: connectTitleComponent(
                                            route.props.title
                                        )
                                    }
                                }))}
                            />
                        </span>
                    </div>
                    {/* Hidden, not removed: it fetches the list of jurisdictions when it mounts, and doing that again would reset the selection. */}
                    <div
                        className={
                            'jurisdiction-select-wrapper' +
                            (hidesJurisdictionSelect(
                                this.props.location.pathname
                            )
                                ? ' hidden'
                                : '')
                        }
                    >
                        <JurisdictionSelectContainer />
                    </div>
                </div>
                <SandboxBanner />

                <Switch children={routes} />
            </div>
        );
    }
}

export default withRouter(MainContent);
